import { combineReducers } from "redux";
import auth from "./authReducer";
import attendance from "./attendanceReducer";

const rootReducer = combineReducers({
  auth,
  attendance,
});

export default rootReducer;
